import SodOpenActionModal from './SodOpenActionModal';

export default SodOpenActionModal;
